// client/src/pages/ReturnsPolicyPage.js
import React from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" fontWeight={700} gutterBottom>{title}</Typography>
    <Typography color="text.secondary" sx={{ lineHeight: 1.8 }}>{children}</Typography>
  </Box>
);

const ReturnsPolicyPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box sx={{ textAlign: 'center', mb: 5 }}>
        <AssignmentReturnOutlinedIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
        <Typography variant="h4" fontWeight={800} gutterBottom>Returns &amp; Refunds</Typography>
        <Typography color="text.secondary">We want you to be happy with every purchase. Here's how returns work.</Typography>
      </Box>

      <Divider sx={{ mb: 4 }} />

      <Section title="30-Day Return Window">
        Most items can be returned within 30 days of delivery for a full refund, provided they're unused, in their
        original packaging, and in the condition you received them.
      </Section>
      <Section title="How to Start a Return">
        Go to My Account → My Orders, open the order, and use the order reference when contacting the seller or our
        support team to arrange your return. We'll confirm the return address and next steps by email.
      </Section>
      <Section title="Refund Timing">
        Once your return is received and inspected, refunds are paid into your bank account by EFT within 5–7
        business days. You'll get an email as soon as it's processed.
      </Section>
      <Section title="Exceptions">
        Items marked as final sale and made-to-order or personalized items are not eligible
        for return unless they arrive faulty or damaged.
      </Section>
      <Section title="Damaged or Incorrect Items">
        If something arrives damaged or isn't what you ordered, contact us within 48 hours of delivery with photos
        of the item — we'll arrange a replacement or full refund at no cost to you, including return shipping.
      </Section>
    </Container>
  );
};

export default ReturnsPolicyPage;
